import { formatDate, ia, iaRa } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import InvoiceEditButton from './InvoiceEditButton';
import TableBodyHeader from './TableBodyHeader';
import TableRow from './TableRow';

const TableContent = ({
  invoiceId,
  dateofservice,
  visibleCols,
  rows,
  preview,
  openModal,
  invoice,
  CustomRowHeader,
  checkin,
  variant
}) => {
  const finalRows = iaRa(rows).filter((row) => row.show);

  if (!ia(finalRows)) return null;
  return (
    <>
      {!checkin && (
        <tr>
          <th colSpan={visibleCols.length} className="p-0">
            <TableBodyHeader
              variant={variant}
              type="alternative"
              columnDefs={visibleCols}
              value={
                dateofservice && (
                  <div className="flex items-center gap-2 pl-7 sm:pl-0">
                    <Typography variant="label" size="medium" weight="medium" color="neutral-700">
                      Date of Service:
                    </Typography>
                    <Typography
                      variant="label"
                      size="medium"
                      weight="medium"
                      color="neutral-500"
                      className="italic">
                      {formatDate(dateofservice)}
                    </Typography>
                  </div>
                )
              }>
              {!preview && (
                <InvoiceEditButton
                  preview={preview}
                  openModal={openModal}
                  invoiceId={invoiceId}
                  invoice={invoice}
                  variant={variant}
                />
              )}
            </TableBodyHeader>
          </th>
        </tr>
      )}
      {finalRows.map((row, index) => (
        <TableRow
          key={index}
          columnDefs={visibleCols}
          row={row}
          idx={index}
          preview={preview}
          variant={variant}
          CustomRowHeader={CustomRowHeader}
        />
      ))}
    </>
  );
};

export default TableContent;
